"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
exports.styles = {
    root: styled_1.default.span `
    align-items: center;
    aspect-ratio: 1;
    color: ${({ color }) => color};
    display: flex;
    height: ${({ size }) => size}px;
    justify-content: center;
    transition: all 0.15s ease-in-out;
    width: ${({ size }) => size}px;
  `,
};
